import React, {Fragment} from 'react';

import TextElement from './TextElement';
import ButtonElement from './ButtonElement';
import ImageElement from './ImageElement';
import VideoElement from './VideoElement';
import AudioElement from './AudioElement';
import TextfieldElement from './TextfieldElement';
import MultipleChoiceElement from './MultipleChoiceElement';
import DropDownElement from './DropDownElement';
import ScaleElement from './ScaleElement';
import ClickAreaElement from './ClickAreaElement';
import DragHandleIcon from 'material-ui-icons/DragHandle';

const ELEMENTS = [
	TextElement,
	ButtonElement,
	ImageElement,
	VideoElement,
	AudioElement,
	TextfieldElement,
	MultipleChoiceElement,
	DropDownElement,
	ScaleElement,
	ClickAreaElement,
];

const REGISTERED_ELEMENTS = {};
ELEMENTS.forEach( Element => { 
	if(!Element.type){ throw new Error('Elements must have a static field "type" set:' + Element.name); }
	if(!Element.Properties){ throw new Error('Elements must have a static field "Properties" set:' + Element.name); }
	if(!Element.defaultJSON){ throw new Error('Elements must have a static field "defaultJSON" set:' + Element.name); }
	REGISTERED_ELEMENTS[Element.type] = Element;
});

const ElementFactory = (props) => {
	let Element = REGISTERED_ELEMENTS[props.element.type];
	let {experiment, element} = props;

	if(!Element){
		debugger;
	}

	let builderProps = {};

	if(!props.live){
		builderProps = {
			onMouseDown: (e)=>{ experiment.selectElement(element, e.metaKey || e.ctrlKey || e.shiftKey ); experiment.forceUpdate(); },
			className: `Element draggable-element ${experiment.isSelectedElement(element) ? 'selected': ''}`,
			onContextMenu: e => { experiment.showElementContextMenu({event:e, element}); } 
		};
	}

	return (
		<div 
			{...builderProps}
			style={{
				position:'absolute',
				left:element.x + 'px',
				top: element.y + 'px',
				width:element.width  + 'px',
				height: element.height  + 'px',
			}}>
			<Element element={props.element} experiment={props.experiment} builder={props.builder} />
			{!props.live && props.element.type !== 'text' && <div className="drag-handle" style={{ position:'absolute', left:0, right:0, top:0, bottom:0}}></div>}
			{!props.live && props.element.type === 'text' && 
				<div className="drag-handle" style={{ position:'absolute', left:'-4px', top:'-18px'}}>
					<DragHandleIcon style={{fill:'#cecece'}} />
				</div>
			}

			{ !!props.builder &&
			<Fragment>
				<div className="resize-handle resize-handle-bottom" style={{ position:'absolute', left:0, right:0, bottom:'-10px', height:'10px'}}></div>
				<div className="resize-handle resize-handle-right" style={{ position:'absolute',  right:'-10px', top:0, bottom:0, width:'10px'}}></div>
				<div className="resize-handle resize-handle-corner" style={{ position:'absolute',  right:'-10px', bottom:'-10px', width:'15px', height:'15px'}}></div>
			</Fragment>
			}

		</div>
	);
}

const Elements = REGISTERED_ELEMENTS

export {
	ElementFactory,
	Elements
};


// WEBPACK FOOTER //
// ./src/components/ScreenElements/Elements.js